<template>
    <div class="filter-item">
        <p>{{filterItem.text}}</p>
        <button @click="removeFilterItem">
            <Icon icon="x"/>
        </button>
    </div>  
</template>

<script>
import Icon from '../../../Theme/Icon.vue'
export default {
    name: 'FilterItem',
    components: {
        Icon
    },
    props: {
        filterItem: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        removeFilterItem: function() {
            this.$emit('onRemove', this.filterItem)
        }
    }
}
</script>

<style lang="scss" scoped>
$font: 'Eina SemiBold';
.filter-item {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background: #EDF2F7;
    border-radius: 4px;
    border: 1px solid #E2E8F0;
    margin-right: 8px;
    margin-bottom: 8px;
    p {
        font-family: $font;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        margin: 0;
    }
    button {
        margin-left: 6px;
        display: flex;
        padding: 0;
    }
}
</style>